import values from "lodash/values";
import isObject from "lodash/isObject";

export default function extractErrorMessage(error: any): string {
  const message = error.content?.errors;
  if (message) {
    if (Array.isArray(message)) {
      const messagesObject = message[0].constraints;
      if (messagesObject) {
        return values(messagesObject)[0];
      }
    } else if (isObject(message)) {
      // ignore if messages is object
    } else {
      return message;
    }
  }

  return error.content?.title || error.response?.statusText || "Server communication error";
}
